import { openSignInModal } from '../templates/_shared/ui-components/SignInModal/utils';
import {
  getAuthModalReturnUrl,
  isAccountLoginPage,
  resolveForcedAuthModalView,
} from '../templates/_shared/ui-components/SignInModal/forcedView';
import { IS_NATIVE_APP_CLIENT } from './helpers';
import { prependLocaleToPath } from './localization';

export const setupAuthHandler = () => {
  const conditionallyShowAuthModal = () => {
    if (isAccountLoginPage()) return;

    const forcedAuthModalView = resolveForcedAuthModalView();
    if (!forcedAuthModalView) return;

    if (forcedAuthModalView.source === 'legacy-hash') {
      window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }

    if (IS_NATIVE_APP_CLIENT) {
      if (forcedAuthModalView.view === 'create-account') {
        window.location.href = prependLocaleToPath('/account/login?newUser=true');
      } else if (forcedAuthModalView.view === 'recovery') {
        window.location.href = `${prependLocaleToPath('/account/login')}#recover`;
      } else {
        window.location.href = prependLocaleToPath('/account/login?newUser=false');
      }
    } else {
      openSignInModal({ returnUrl: getAuthModalReturnUrl(), tab: forcedAuthModalView.view });
    }
  };

  conditionallyShowAuthModal();
  window.addEventListener('hashchange', conditionallyShowAuthModal);
};
